import { Component, Vue } from 'vue-property-decorator'


@Component
export default class FallbackImge extends Vue {
  protected fallback(event: any, path: string) {
    event.target.src = path
  }
}
